import { Rect } from "yfiles";
export default (graph, node, size, maxSize, updateTag) => {
    var _a;
    const preferredSize = ((_a = node.labels.firstOrDefault()) === null || _a === void 0 ? void 0 : _a.preferredSize) || size;
    if (!preferredSize)
        return;
    const newLayout = new Rect(node.layout.x, node.layout.y, Math.min(preferredSize.width, maxSize.width), Math.min(preferredSize.height, maxSize.height));
    if (updateTag) {
        if (!node.tag)
            return;
        node.tag = {
            ...node.tag,
            NodeWidth: newLayout.width,
            NodeHeight: newLayout.height
        };
    }
    graph.setNodeLayout(node, newLayout);
};
